import React from "react";
import { useAuth } from "../AuthContext";
import useBlockedUsers from "../hooks/useBlockedUsers";
import ReportButton from "./ReportButton";

/**
 * "Report" (anyone) and "Block" (signed-in) links shown on each comment by someone else.
 * Guest comments carry negative ids and can be reported but not blocked.
 */
export default function CommentActions({ comment, targetTitle }) {
  const { user } = useAuth();
  const { block } = useBlockedUsers();
  if (!comment) return null;
  const mine = user && Number(user.userId) === Number(comment.userId);
  if (mine) return null;
  const canBlock = user && comment.userId > 0;

  const onBlock = async () => {
    // eslint-disable-next-line no-alert
    if (!window.confirm(`Block ${comment.userName || "this person"}? You won't see their comments or content, and neither of you can message the other. You can unblock them in Account → Privacy & account settings.`)) return;
    try { await block(comment.userId); } catch { /* ignore */ }
  };

  return (
    <span className="comment-actions">
      <ReportButton targetType="COMMENT" targetId={comment.id} targetUserId={comment.userId > 0 ? comment.userId : null}
        targetTitle={targetTitle ? `comment on ${targetTitle}` : "comment"} />
      {canBlock && <button type="button" className="report-btn" onClick={onBlock}>Block</button>}
    </span>
  );
}
